<template>
    <form action="" class="w-full max-w-full min-w-0 space-y-5" :class="{ 'farm-form-full-page': fullPage }" v-on:submit.prevent="createFarm">
        <FormErrors :errors="vuelidate.$errors" />
        <InputComponent type="text" placeholder="Nombre" :value="vuelidate.farm.name.$model" v-model="vuelidate.farm.name.$model" />

        <div>
            <h3 class="mb-1 text-lg font-bold text-enriqueto_green">Ubicación y linderos</h3>
            <p class="mb-3 text-sm text-gray-700">
                Selecciona la finca y dibuja su contorno en el mismo mapa satelital.
            </p>
            <FarmBoundaryMap
                :center="[-76.3193821,3.39877]"
                id="mapaFincaNueva"
                :full-page="fullPage"
                @selected-location="updateLocation($event)"
                @selected-area="updateArea($event)"
            />
        </div>

        <div class="grid gap-4 p-4 sm:grid-cols-2 bg-light_yellow rounded-2xl">
            <label>
                <span class="block mb-2 text-sm font-bold text-enriqueto_green">Mostrar el área en</span>
                <select v-model="farm.area_unit" class="w-full p-3 bg-white border rounded-xl border-light_green">
                    <option value="ha">Hectáreas (ha)</option>
                    <option value="m2">Metros cuadrados (m²)</option>
                </select>
            </label>
            <label>
                <span class="block mb-2 text-sm font-bold text-enriqueto_green">Área calculada</span>
                <input
                    class="w-full p-3 bg-white border rounded-xl border-light_gray"
                    :value="displayArea"
                    readonly
                    placeholder="Dibuja los linderos para calcularla"
                />
            </label>
        </div>

        <SubmitButtonComponent :value="saving ? 'Guardando…' : 'Guardar'" :disabled="saving"/>
    </form>
</template>

<script>
import { ref } from '@vue/reactivity'
import { computed, watch } from 'vue';
import InputComponent from './InputComponent.vue'
import SubmitButtonComponent from './SubmitButtonComponent.vue'
import FormErrors from './FormErrors.vue'
import useVuelidate from '@vuelidate/core'
import { required, numeric } from '@vuelidate/validators'
import useApi from '../../Services/useApi'
import useNotification from '../../Services/useNotification'
import FarmBoundaryMap from '../Map/FarmBoundaryMap.vue'

const createSubmissionToken = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID()
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
        const random = Math.floor(Math.random() * 16)
        const value = character === 'x' ? random : (random & 0x3) | 0x8
        return value.toString(16)
    })
}

export default {
    components: { InputComponent, SubmitButtonComponent, FormErrors, FarmBoundaryMap },
    props: ['farm', 'fullPage'],
    validations() {
        return {
            farm: {
                name: {
                    required
                },
                size: {
                    required
                },
                lon: {
                    required
                },
                lat: {
                    required
                },
                area_unit: {
                    required
                }
            },
        }
    },
    setup(props,{emit}){
        const vuelidate = useVuelidate();
        const api = useApi();
        const farm= ref(props.farm)
        farm.value.area_unit = farm.value.area_unit || 'ha'
        farm.value.area = farm.value.area || []
        const isEdit = farm.value.name!=''
        const notificate = useNotification()
        const areaSquareMeters = ref(0)
        const saving = ref(false)
        const submissionToken = ref(createSubmissionToken())

        const displayArea = computed(() => {
            if (!areaSquareMeters.value) {
                return ''
            }

            return farm.value.area_unit === 'ha'
                ? `${farm.value.size} ha`
                : `${farm.value.size} m²`
        })

        const updateStoredArea = () => {
            if (!areaSquareMeters.value) {
                farm.value.size = ''
                return
            }

            farm.value.size = farm.value.area_unit === 'ha'
                ? Math.round((areaSquareMeters.value / 10000) * 10000) / 10000
                : Math.round(areaSquareMeters.value * 100) / 100
        }

        watch(() => farm.value.area_unit, updateStoredArea)

        const createFarm = async()=>{
            if (saving.value) {
                return
            }

            let validation = await vuelidate.value.$validate();
            if (!farm.value.area || farm.value.area.length < 4) {
                notificate.error('Delinea los linderos de la finca antes de guardar')
                return
            }

            if(validation){
                saving.value = true
                try {
                    const response = await api.addFarm({
                        ...farm.value,
                        submission_token: submissionToken.value,
                    })
                    farm.value = response.data.farm
                    notificate.success('Guardado con exito')
                    emit('added', response.data.farm)
                } catch (error) {
                    saving.value = false
                    notificate.error('No fue posible guardar la finca')
                }
            }else{
                notificate.error('Revisa el formulario')
            }
        }

        const updateLocation = (location) => {
            if (!Array.isArray(location) || location.length < 2) {
                farm.value.lon = ''
                farm.value.lat = ''
                return
            }

            farm.value.lon = location[0]
            farm.value.lat = location[1]
        }

        const updateArea = (location) => {
            farm.value.area = location.locations
            areaSquareMeters.value = location.area
            updateStoredArea()
        }

        return{
            farm,
            createFarm,
            vuelidate,
            isEdit,
            updateLocation,
            updateArea,
            displayArea,
            saving
        }
    }
}
</script>

<style>

</style>
